/* eslint-disable */
export const nodeEnv = process.env.NODE_ENV;
export const appEnv = process.env.VUE_APP_ENV;

export const isDevelopment = appEnv === "development";
export const isStage = appEnv === "stage";
export const isProduction = appEnv === "production";
